module.exports = __webpack_public_path__ + "static/media/icon_nav_sales_active.d9d9bfc9.svg";